import { useState as i, useRef as p, useEffect as y } from "react";
const m = ({ key: e }) => e.length === 1 || e.length > 1 && /[^a-zA-Z0-9]/.test(e), k = (e = {}) => {
  const { timeout: n = 300, preventDefault: a = () => !0 } = e, [c, s] = i([]), r = p(null), u = () => {
    r.current && (clearTimeout(r.current), r.current = null);
  }, l = () => {
    u(), r.current = setTimeout(() => {
      s([]), r.current = null;
    }, n);
  };
  return y(() => u, []), (f) => (t) => {
    if (t.key === "Backspace") {
      const o = [...c];
      o.pop(), s(o);
      return;
    }
    if (m(t)) {
      const o = c.concat(t.key);
      a(t) && (t.preventDefault(), t.stopPropagation()), s(o), f(o.join("")), l();
    }
  };
};
export {
  k as useShortcut
};
//# sourceMappingURL=useShortcut.js.map
